import PhoneIcon from '@mui/icons-material/Phone';
import { HelperText } from '@qbe/ads-blocks-forms';
import { Box, Icon, Skeleton, Typography } from '@qbe/ads-core';
import React from 'react';

import { useAppContent } from '~/hooks';

const FloatingContactUs: React.FC = () => {
  const { status, getTextContent, getJSXContent } = useAppContent({
    basePath: 'dsme.floatingContactUs',
  });

  const isReady = status === 'ready';

  return (
    <HelperText
      variant="light"
      overrideBackground="transparent"
      disableShadow
      header={
        isReady ? (
          <Box>
            <Typography variant="subtitle1">{getTextContent('title')}</Typography>
            <Typography variant="subtitle2">{getTextContent('description')}</Typography>
          </Box>
        ) : (
          <Box>
            <Skeleton variant="text" height="30px" animation="wave">
              &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
            </Skeleton>
            <Skeleton variant="text" height="24px" animation="wave">
              &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
            </Skeleton>
            <Skeleton variant="text" height="24px" animation="wave">
              &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
            </Skeleton>
          </Box>
        )
      }
      content={
        isReady ? (
          <Typography variant="h6">
            <Icon muiIcon={PhoneIcon} color="black" size={20} />{' '}
            {getJSXContent('content.phone.description')}
          </Typography>
        ) : (
          <Skeleton variant="text" height="30px" animation="wave">
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
          </Skeleton>
        )
      }
      footer={
        isReady ? (
          <Typography>{getTextContent('content.contactHours.description')}</Typography>
        ) : (
          <Skeleton variant="text" height="24px" animation="wave">
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
          </Skeleton>
        )
      }
    />
  );
};

export default FloatingContactUs;
